module.exports = __webpack_public_path__ + "img/menu4.4f6879e7.png";